import { Typography } from "@mui/material";
import { Col, Row } from "v2/components/base/Flex/ui";
import CloseButtons from "v2/components/Buttons/CloseButton";
import { withModelHeaderWrapper } from "../../hocs/withModelHeaderWrapper";
import { withHeaderCloseButton } from "../../hocs/withHeader";
import { withHeaderTitle } from "../../hocs/withHeader";

const ModelHeaderWrapper = ({ children, ...props }: { children: React.ReactNode }) => {
  return (
    <Row section="header" type="bc" fullWidth {...props}>
      {children}
    </Row>
  );
};

const ModelHeaderTitle = ({ children, ...props }: { children: React.ReactNode }) => {
  return (
    <Col section="title" type="cs" {...props}>
      {children}
    </Col>
  );
};

const ModelHeaderCloseButtonWrapper = ({ children, ...props }: { children: React.ReactNode }) => {
  return (
    <Col section="close-button" type="ce" {...props}>
      {children}
    </Col>
  );
};

const ModelHeader = {
  Wrapper: withModelHeaderWrapper(ModelHeaderWrapper),
  Title: withHeaderTitle(ModelHeaderTitle),
  CloseButton: withHeaderCloseButton(ModelHeaderCloseButtonWrapper, CloseButtons),
};

export default ModelHeader;
